export const getCurrentPath = (parentPath: any, currentKey: any) => {
	if (currentKey) {
		return [...parentPath, currentKey];
	}
	return [...parentPath];
};

export const getCurrentDefaultValue = (defaultValue: any, currentKey: any) => {
	if (!defaultValue || !currentKey) {
		return defaultValue;
	}

	return { ...defaultValue, path: [...defaultValue.path, currentKey] };
};
